import { LOCALES, SAVIOR_CLASS } from "../constants";

// 잠재력 아이콘 배경 색상: 일반 잠재력 yellow, 특정 캐릭터 전용 red, 역할(클래스) 전용 blue, 나머지 특수 잠재력 special.
const getPotentialBgKey = (potential) => {
    if (potential.type === "일반 잠재력") return "yellow";
    if (potential.unitId && potential.unitId !== 0) return "red";
    if (potential.class && potential.class !== "") return "blue";
    return "special";
};

// potential.class는 "스트라이커" 같은 한글 리터럴로 저장돼 있어, SAVIOR_CLASS의 ko-KR 값과
// 매칭해 영문 등 다른 언어 라벨을 얻는다.
const getLocalizedClassName = (lang, classNameKo) => {
    const found = Object.values(SAVIOR_CLASS).find((c) => c[LOCALES.KO] === classNameKo);
    return found ? found[lang] : classNameKo;
};

// 잠재력 뱃지에 표시할 라벨: 일반 잠재력 / {캐릭터명} 전용 / {역할} 전용 / 특수 잠재력
const getPotentialTypeLabel = (lang, potential) => {
    const onlySuffix = lang === LOCALES.KO ? " 전용" : " Only";

    if (potential.type === "일반 잠재력") {
        return lang === LOCALES.KO ? "일반 잠재력" : "General";
    }
    if (potential.unitId && potential.unitId !== 0) {
        return `${potential.unitName?.[lang] ?? potential.unitId}${onlySuffix}`;
    }
    if (potential.class && potential.class !== "") {
        return `${getLocalizedClassName(lang, potential.class)}${onlySuffix}`;
    }
    return lang === LOCALES.KO ? "특수 잠재력" : "Special";
};

export { getPotentialBgKey, getPotentialTypeLabel };
